var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.287,
    height: 24.936,
    viewBox: "0 0 34.287 24.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck-delivery",
    d: "M4.117,4A3.117,3.117,0,0,0,1,7.117V24.26H4.117a4.675,4.675,0,1,0,9.351,0h9.351a4.675,4.675,0,1,0,9.351,0h3.117V16.468l-4.675-6.234H25.936V4M15.026,7.117l6.234,6.234-6.234,6.234V14.909H5.675V11.792h9.351m10.909.779h3.9l3.07,3.9H25.936M8.792,21.923A2.338,2.338,0,1,1,6.455,24.26a2.338,2.338,0,0,1,2.338-2.338m18.7,0a2.338,2.338,0,1,1-2.338,2.338A2.338,2.338,0,0,1,27.494,21.923Z",
    transform: "translate(-1 -4)",
    fill: "#e6a900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.1431ca23e8c8aac188e1e5b11dbf0e8e.svg";
export { ForwardRef as ReactComponent };